// File: clientapp/src/pages/SecuritySettings.js
import React, { useEffect, useState } from 'react';
import { Container, Typography, Paper, Box, TextField, FormControlLabel, Checkbox, Button } from '@mui/material';

export default function SecuritySettings() {
    const [settings, setSettings] = useState(null);
    const [office365Enabled, setOffice365Enabled] = useState(false);
    const [internalEnabled, setInternalEnabled] = useState(true);
    const [officeConfig, setOfficeConfig] = useState({
        Instance: "",
        Domain: "",
        TenantId: "",
        ClientId: "",
        CallbackPath: ""
    });
    const [message, setMessage] = useState("");

    useEffect(() => {
        fetchSettings();
    }, []);

    async function fetchSettings() {
        try {
            const response = await fetch('/api/security/settings/identityAuthorization', {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                // response.json() returns an object, so we don't need to parse it again.
                const data = await response.json();
                setSettings(data);
                setOffice365Enabled(data.Office365.enabled);
                setInternalEnabled(data.Internal.enabled);
                setOfficeConfig(data.Office365.config);
            }
        } catch (err) {
            console.error(err);
        }
    }

    const handleSubmit = async () => {
        const newSettings = {
            Office365: {
                enabled: false, // Always false for now
                config: officeConfig
            },
            Internal: {
                enabled: true // Always true
            }
        };

        try {
            const response = await fetch('/api/security/settings/identityAuthorization', {
                method: 'PUT',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(newSettings)
            });
            if (response.ok) {
                // No need to parse again if response.json() returns an object
                const updated = await response.json();
                setMessage("Settings updated successfully.");
                setSettings(updated);
            } else {
                setMessage("Failed to update settings.");
            }
        } catch (err) {
            console.error(err);
            setMessage("Error updating settings.");
        }
    };

    return (
        <Container>
            <Typography variant="h5" gutterBottom>Identity / Authorization Settings</Typography>
            <Paper style={{ padding: 16, marginTop: 16 }}>
                <Box mb={2}>
                    <FormControlLabel
                        control={<Checkbox checked={internalEnabled} disabled />}
                        label="Internal (Embedded) Authentication"
                    />
                    <FormControlLabel
                        control={<Checkbox checked={office365Enabled} disabled />}
                        label="Office 365 Authentication"
                    />
                </Box>
                <Box mb={2}>
                    <Typography variant="subtitle1">Office 365 Configuration</Typography>
                    <TextField
                        label="Instance"
                        fullWidth
                        margin="normal"
                        value={officeConfig.Instance}
                        onChange={(e) => setOfficeConfig({ ...officeConfig, Instance: e.target.value })}
                        disabled
                    />
                    <TextField
                        label="Domain"
                        fullWidth
                        margin="normal"
                        value={officeConfig.Domain}
                        onChange={(e) => setOfficeConfig({ ...officeConfig, Domain: e.target.value })}
                        disabled
                    />
                    <TextField
                        label="Tenant ID"
                        fullWidth
                        margin="normal"
                        value={officeConfig.TenantId}
                        onChange={(e) => setOfficeConfig({ ...officeConfig, TenantId: e.target.value })}
                        disabled
                    />
                    <TextField
                        label="Client ID"
                        fullWidth
                        margin="normal"
                        value={officeConfig.ClientId}
                        onChange={(e) => setOfficeConfig({ ...officeConfig, ClientId: e.target.value })}
                        disabled
                    />
                    <TextField
                        label="Callback Path"
                        fullWidth
                        margin="normal"
                        value={officeConfig.CallbackPath}
                        onChange={(e) => setOfficeConfig({ ...officeConfig, CallbackPath: e.target.value })}
                        disabled
                    />
                </Box>
                <Button variant="contained" onClick={handleSubmit}>Save Settings</Button>
                {message && (
                    <Typography variant="body2" style={{ marginTop: 16, color: 'green' }}>{message}</Typography>
                )}
            </Paper>
        </Container>
    );
}
